import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthStorageGuard, TokenGuard } from 'core-lib';

import { InicialComponent } from './pages/inicial/inicial.component';

const routes: Routes = [{
  path: 'issqn',
  component: InicialComponent,
  canActivate: [TokenGuard]
},{
  path: 'issqn/nota-fiscal',
  canActivate: [AuthStorageGuard],
  loadChildren: () => import('./modules/nota-fiscal/nota-fiscal.module').then(m => m.NotaFiscalModule)
}];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
